import groq from 'groq';

import { ASSET } from './asset';

export const IMAGES_ROTATION_HERO = groq`
  hero {
    title,
    description,
    cta {
      href,
      title,
    },
    images[] {
      ${ASSET}
    }
  }
`;
